<template>
  <div class="announcement">
    <div class="start">{{ $t('start') }}</div>
    <div class="paragraph">{{ $t('para1') }}</div>
    <div class="paragraph">
      <div>{{ $t('para2') }}</div>
      <div class="font-sm">{{ $t('para2_1') }}</div>
      <div class="font-sm">{{ $t('para2_2') }}</div>
    </div>
    <div class="paragraph">{{ $t('para3') }}</div>
    <div>{{ $t('regards') }}</div>
    <div class="paragraph" style="margin-bottom: 60px">{{ $t('team') }}</div>
  </div>
</template>

<script>
export default {
  name: 'Announcement',
  i18n: {
    messages: {
      en: {
        start: 'Dear valued Lender,',
        para1: 'Kredit Pintar is currently undergoing upgrades and improvements the platform. For this reason we will not be continuing to accept your funds at the moment. We sincerely apologize for the inconvenience and assure you that users who are currently funding loans in progress, the funding period will continue until the loan period is complete and/or the borrowers have paid and will be auto transferred to your registered bank account.',
        para2: 'You can access your information by: ',
        para2_1: '(1) Using the Kredit Pintar phone app if already installed, or visiting www.lending.kreditpintar.com where you can see agreements, loan period maturity, and normal information. When it matures the funds will be transferred to your registered bank account and can no longer can re-lend. ',
        para2_2: '(2) You can contact Kredit Pintar’s Customer Service  at pendanaan@kreditpintar.com for further information about your lending period',
        para3: 'We hope you continue stay updated with Kredit Pintar on social media and keep an eye out for exciting announcements. If you have any questions or concerns, please let us via email: pendanaan@kreditpintar.com or WhatsApp us at +6281324887208. We\'ll see you again soon!',
        regards: 'Kind regards,',
        team: 'Kredit Pintar Team',
      },
      id: {
        start: 'Pengguna yang terhormat,',
        para1: 'Kredit Pintar saat ini sedang mengoptimasi platform. Karena alasan ini, kami tidak akan menerima dana Anda saat ini. Kami dengan tulus meminta maaf atas ketidaknyamanan ini dan meyakinkan Anda bahwa pengguna yang saat ini mendanai pinjaman sedang berlangsung, periode pendanaan akan berlanjut sampai periode pendanaan selesai dan / atau peminjam telah membayar dan akan secara otomatis ditransfer ke rekening bank terdaftar Anda.',
        para2: 'Anda dapat mengakses informasi Anda dengan:',
        para2_1: '(1) Menggunakan aplikasi Kredit Pintar jika sudah diunduh, atau mengunjungi www.lending.kreditpintar.com di mana Anda dapat melihat perjanjian, jatuh tempo masa pinjaman, dan informasi lainnya. Ketika jatuh tempo dana akan ditransfer ke rekening bank terdaftar Anda dan tidak lagi dapat meminjamkan kembali.',
        para2_2: '(2) Anda dapat menghubungi Layanan Pelanggan Kredit Pintar di pendanaan@kreditpintar.com untuk informasi lebih lanjut tentang periode pinjaman Anda.\n',
        para3: 'Kami berharap Anda terus mengikuti update Kredit Pintar di media sosial dan tidak melewatkan pengumuman menarik. Jika Anda memiliki pertanyaan atau masalah, silakan beri tahu kami melalui email: pendanaan@kreditpintar.com atau WhatsApp kami di +6281324887208. Kami akan segera bertemu lagi!',
        regards: 'Salam,',
        team: 'Tim Kredit Pintar',
      },
    },
  },
}
</script>

<style scoped lang="stylus">
.announcement
  min-height: calc(100vh - 64px)
  padding 30px 20px
  font-size 15px
  letter-spacing 0.1px
  line-height 20px

.start
  margin-bottom 10px
  font-weight bold

.paragraph
  margin-bottom 18px

.font-sm
  font-size 12px
  line-height 18px
</style>
